module.exports = __webpack_public_path__ + "media/images/vp/icon.removefriend.white-60197a446312dd65f9d2a815265203a2.svg";